<template lang="pug">
#about-view
  second-menu(:selectorid="'tab-selector-base'", :tabs="tabs", :synctab.sync="selectedTab", :is-sticky='true')
  #about-view-content
    router-view
</template>

<script>
import router from './../../router'
import Uri from 'urijs'
import SecondMenu from '../second-menu.vue'

let tabs = [
  {
    title: window.wordDict.ABOUT_GLOBAL,
    id: 'profile',
  }, {
    title: window.wordDict.ABOUT_TEAM,
    id: 'team',
  // }, {
  //   title: window.wordDict.ABOUT_CG,
  //   id: 'corporate-governance',
  }, {
    title: window.wordDict.ABOUT_SR_PROJECTS,
    id: 'social-responsibility-projects',
  }
]


export default {
  data () {
    return {
      selectedTab: Uri().segment(1),
      tabs,
    }
  },
  computed: {},
  ready () {
    console.log(this.$route);
  },
  watch: {
    selectedTab(val) { console.log(val); router.go(`/about/${val}`) },
  },
  attached () {},
  methods: {},
  components: {
    SecondMenu
  }
}
</script>

<style lang="scss">
@import "global";
#about-view {
  @media (max-width:$grid-float-breakpoint-max) {
    #tab-selector-base.tab-selector {
      &[selected="team"], &[selected="corporate-governance"] {
        width: 50%;
        .mdl-tabs__tab {
          border-right: $responsive-mdl-selector-border;
        }
        .tab-select-icon {
          right: 12px;
        }
      }
    }
    #about-view-content {
      margin-top: $responsive-mdl-selector-height + 1px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// about-page.vue?77f16315